// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"113":"tgBrightcove","294":"tgGallery"}[chunkId] || chunkId) + "." + {"113":"5d2d0fbebdc5ad14ee42","294":"94a12d8899ebe8c2e0d8","851":"400d8c24cd995f4430e5"}[chunkId] + ".min.js";
};